module.exports = __webpack_public_path__ + "media/images/cbjj/academy_registration_informations/kids_final_authority-b93f0cf87676fe9c22398d42ff9586e4.svg";